interface StaticCheckboxProps {
  checked: boolean;
  size?: number;
  round?: boolean;
}

// Read-only checkbox/radio mark drawn as a plain bordered box instead of a
// native <input disabled>, which browsers render washed-out gray regardless
// of any color CSS — this keeps the border and the check mark solid black to
// match the rest of the read-only "paper document" view.
export default function StaticCheckbox({ checked, size = 11, round = false }: StaticCheckboxProps) {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        minWidth: size,
        flexShrink: 0,
        boxSizing: 'border-box',
        border: '1px solid #1a2942',
        borderRadius: round ? '50%' : 0,
        background: 'transparent',
        lineHeight: 1,
      }}
    >
      {checked && (
        <span style={{ fontSize: size * (round ? 0.5 : 0.85), fontWeight: 900, color: '#1a2942' }}>
          {round ? '●' : '✓'}
        </span>
      )}
    </span>
  );
}
